export default __webpack_public_path__ + "static/media/banner-home-1920x1080.bbef85b4.png";